// extracted by mini-css-extract-plugin
export default {"updateComponent_inputLabels":"UpdateModal_updateComponent_inputLabels__XM5wl","updateComponent_inputFields":"UpdateModal_updateComponent_inputFields__BFISj"};